import Numeral from 'numeral';
import Cache from 'root/cache';
import View from 'view/base';

export default View.extend({
    className: 'project-performance',

    mode: 'sidebar',

    initialize: function(options) {
        this.mode = options.mode || 'sidebar';

        this.listenTo(Cache.statistics, 'change:project_count', this.render);
    },

    render: function() {
        var project_overview  = Cache.statistics.get('project_count') ? Cache.statistics.get('project_count')[this.model.id] : false;
        var total_response    = project_overview ? project_overview['count'] : 0;
        var total_impressions = project_overview ? project_overview['impressions'] : 0;

        var content =
        '<div>' +
            '<div class="font-weight-medium">' + (this.mode === 'sidebar' ? 'Total ' : '') +  (this.model.isFeedback() ? 'Feedback' : 'Responses') + '</div>' +
            '<div class="margin-top-8 text-xlarge font-weight-semibold">' + Numeral(total_response).format('0,0') + '</div>' +
        '</div>' +

        (this.mode === 'sidebar' ?
        '<div class="text-info margin-top-8">' + Numeral(total_impressions).format('0,0') + ' impressions</div>' :
        '<div>' +
            '<div class="font-weight-medium">Impressions</div>' +
            '<div class="margin-top-8 text-xlarge font-weight-semibold">' + Numeral(total_impressions).format('0,0') + '</div>' +
        '</div>');

        this.$el.html(content);

        this.$el.attr('data-mode', this.mode);

        return this;
    }
});